// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1886":"fe49a764","6321":"e2599494","7959":"7481bc61","8354":"33651cce"}[chunkId] + ".chunk.css";
};